import { gql } from 'apollo-angular';

export const GET_DD_REPORT = gql`
  query getDDReport($filters: ReportFilterInput!) {
    getDDReport (filters:$filters ){jobId,status, message}
  }
`;

export const GET_ENQUIRY_REPORT = gql`
  query getEnquiryReport($filters: ReportFilterInput!)  {
    getEnquiryReport (filters:$filters){jobId,status, message}
  }
`;

export const DOWNLOAD_REPORT = gql`
  query generateSignedUrl($filters: ReportDownloadInput!) {
    generateSignedUrl (filters:$filters ){jobId,status, message}
  }
`;